@if (!loading) {
  @if (displayPopover) {
    <div>
      <a
        href="#"
        class="small text-nowrap {{ linkClass }}"
        (click)="$event.preventDefault()"
        [ngbPopover]="popoverContent"
        placement="bottom"
        container="body"
        >
        {{ linkLabel }}
      </a>
      @if (canAddNotes) {
        <a
          href="#"
          class="small text-nowrap {{ linkClass }}"
          (click)="onClick($event)"
          >
          <fa-icon [icon]="['fas', 'file-signature']" size="sm" title="{{ linkLabelTitle }}" />
        </a>
      }
      <ng-template #popoverContent>
        @for (note of providerOffice.notes; track note) {
          <app-note [note]="note" />
        }
      </ng-template>
    </div>
  } @else {
    <div>
      @if (canAddNotes) {
        <a
          href="#"
          class="small text-nowrap {{ linkClass }}"
          (click)="onClick($event)"
          >
          {{ linkLabel }}
          <fa-icon [icon]="['fas', 'file-signature']" size="sm" title="{{ linkLabelTitle }}" />
        </a>
      }
    </div>
  }
} @else {
  <mat-spinner [diameter]="20" />
}

